module.exports = __webpack_public_path__ + "static/media/companyLogo3.b3be26f2.png";